var map = {
	"./add-new-activity.modal.tsx": [
		703,
		703
	],
	"./add-new-user.modal.tsx": [
		2096,
		96
	],
	"./class-form.modal.tsx": [
		1592,
		592
	],
	"./course-form.modal.tsx": [
		2907,
		907
	],
	"./manage-roles.modal.tsx": [
		9045,
		45
	],
	"./settings.modal.tsx": [
		622,
		622
	],
	"./teacher-requirement-form.modal.tsx": [
		3945,
		945
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4197;
module.exports = webpackAsyncContext;